import { useCallback } from 'react';

import { useEmptyStructure } from 'hooks/useObjectStructure';
import { isDocumentTypeWithLocations, isDocumentTypeWithTransportUnits } from 'services/documentTypes/documentTypes';
import { DocumentType } from 'support/types';

import { useDataTableContext } from 'components/DataTable/contexts/DataTableContext';
import { ColumnTypesInternal } from 'components/DataTable/Types';

export const useAppendLineItem = (documentType: DocumentType) => {
  const { fields, append } = useDataTableContext();
  const emptyLineItem = useEmptyStructure(fields);

  const appendLineItem = useCallback(() => {
    let internalFields: Record<string, string | boolean> = {
      [ColumnTypesInternal.procuros_added]: true,
    };

    if (isDocumentTypeWithTransportUnits(documentType)) {
      internalFields = {
        ...internalFields,
        parent_transport_unit: "$['transport_units'][0]",
      };
    } else if (isDocumentTypeWithLocations(documentType)) {
      internalFields = {
        ...internalFields,
        parent_location: "$['locations'][0]",
      };
    }

    append({
      ...emptyLineItem,
      _internal: internalFields,
    });

    setTimeout(() => {
      const table = document.getElementById('line_items');
      table?.scrollTo({ top: table.scrollHeight });
    }, 1000);
  }, [documentType, emptyLineItem, append]);

  return appendLineItem;
};
